import { DialogService, GridAction } from '@eforall/dashboard';
import { AccVentureDialog } from '../../../../../../../ui/widget';
import { DeliveryAreaService } from '../../../../../delivery-area.service';
import { DeliveryAward } from '../all-awards-view.part';

export function getActions(dialog: DialogService, areaService: DeliveryAreaService): GridAction<DeliveryAward>[] {

	const actions: GridAction<DeliveryAward>[] = [
		{
			iconClass: 'fa-regular fa-pencil',
			label: 'View Venture Details',
			isEnabled: rows => !!rows.length,
			execute: async rows => {
				await dialog.showCustom(AccVentureDialog, { data: { accVentureId: rows[0]!.accVentureId } }, 900, 700);
				await areaService.reloadData();
			}
		}
	];

	return actions;
}